// The Telegram channel the whale alert bot posts to. One place for it because
// the site links to it from more than one, and because the handle and the URL
// have to agree - a link reading @d2index that opens a different channel is a
// worse bug than no link at all.
//
// netlify/shared/whale-alerts.mjs does not read this: the bot is told where to
// post by TELEGRAM_CHAT_ID in Netlify, so the channel can be changed there
// without a deploy. This constant is what the site claims, and the two are
// kept in step by hand.
export const TELEGRAM_HANDLE = "@d2index";
export const TELEGRAM_URL = "https://t.me/d2index";
